import React from 'react';
import { Card, Button, Alert } from '@dopomogai/ui';

type Props = {
  sharesPurchased: number;
  newBalanceCredits: number;
  onViewPortfolio: () => void;
};

export function InvestmentSuccessPanel({ sharesPurchased, newBalanceCredits, onViewPortfolio }: Props) {
  return (
    <Card>
      <div className="p-4 space-y-3">
        <Alert type="success" title="You’re in!" message={`Purchased ${sharesPurchased} shares. New balance: ${newBalanceCredits} cr.`} />
        <div className="flex gap-3">
          <Button text="View portfolio" onClick={onViewPortfolio} />
        </div>
      </div>
    </Card>
  );
}


